module.exports = __webpack_public_path__ + "static/media/YM39_0.1aa835a3.jpg";